module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-109.18ef78ec.svg";